var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"pz-config-load-progress-container"},[_c('mn-component-view',{key:_vm.contextKey + '-loading',attrs:{"view":_vm.ProgressDialog,"options":_vm.progressDialogOptions}})],1):(_vm.datamart)?_c('router-view',{key:_vm.contextKey,attrs:{"datamart":_vm.datamart,"context":_vm.context,"config":_vm.config}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }